import { Link, useLocation, useNavigate } from "react-router-dom";
import { Waveform, ClockCounterClockwise, ChartBar, SignOut, FilmSlate, Microphone } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";

export default function Layout({ children }) {
  const loc = useLocation();
  const nav = useNavigate();
  const { user, logout } = useAuth();
  const isVideo = loc.pathname.startsWith("/video");

  const audioNav = [
    { to: "/", label: "New Dub", icon: Waveform, testid: "nav-new-dub" },
    { to: "/history", label: "Run History", icon: ClockCounterClockwise, testid: "nav-history" },
    { to: "/scorecard", label: "Scorecard", icon: ChartBar, testid: "nav-scorecard" },
  ];
  const videoNav = [
    { to: "/video", label: "New Video", icon: FilmSlate, testid: "nav-new-video" },
    { to: "/video/history", label: "Video Runs", icon: ClockCounterClockwise, testid: "nav-video-history" },
    { to: "/video/scorecard", label: "Scorecard", icon: ChartBar, testid: "nav-video-scorecard" },
  ];
  const sub = isVideo ? videoNav : audioNav;

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-[#18181B] border-b border-border sticky top-0 z-40">
        <div className="flex items-stretch flex-wrap">
          <div className="flex items-center gap-3 px-6 py-4 border-r border-border">
            <div className="h-7 w-7 bg-primary flex items-center justify-center">
              <Waveform weight="bold" className="text-black" size={18} />
            </div>
            <div className="leading-none">
              <div className="font-mono font-extrabold tracking-tighter text-sm">RELAY<span className="text-primary">/</span>AI</div>
              <div className="overline mt-1" style={{ fontSize: "0.55rem" }}>orchestration lab</div>
            </div>
          </div>

          <div className="flex items-stretch border-r border-border">
            <Link to="/" data-testid="tool-audio" className={`flex items-center gap-2 px-5 text-sm font-mono transition-colors ${!isVideo ? "bg-primary text-black" : "text-muted-foreground hover:text-foreground hover:bg-secondary"}`}>
              <Microphone size={16} weight={!isVideo ? "fill" : "regular"} /> Audio Dub
            </Link>
            <Link to="/video" data-testid="tool-video" className={`flex items-center gap-2 px-5 text-sm font-mono transition-colors ${isVideo ? "bg-primary text-black" : "text-muted-foreground hover:text-foreground hover:bg-secondary"}`}>
              <FilmSlate size={16} weight={isVideo ? "fill" : "regular"} /> Video Studio
            </Link>
          </div>

          <nav className="flex items-stretch">
            {sub.map((n) => {
              const active = loc.pathname === n.to;
              const Icon = n.icon;
              return (
                <Link key={n.to} to={n.to} data-testid={n.testid}
                  className={`flex items-center gap-2 px-5 border-r border-border text-sm font-mono transition-colors ${active ? "text-primary bg-background" : "text-muted-foreground hover:text-foreground hover:bg-secondary"}`}>
                  <Icon size={15} /> {n.label}
                </Link>
              );
            })}
          </nav>

          <div className="ml-auto flex items-center gap-4 px-6 border-l border-border">
            <div className="text-right leading-tight hidden sm:block">
              <div className="text-xs font-mono">{user?.email}</div>
              <div className="overline" style={{ fontSize: "0.5rem" }}>{user?.role}</div>
            </div>
            <button data-testid="logout-button" onClick={async () => { await logout(); nav("/login"); }}
              className="flex items-center gap-1.5 text-xs font-mono text-muted-foreground hover:text-destructive transition-colors">
              <SignOut size={16} /> exit
            </button>
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-[1400px] w-full mx-auto px-6 py-10">{children}</main>
    </div>
  );
}
